import {Component, OnInit, SecurityContext, ViewChild, ViewEncapsulation} from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  UntypedFormBuilder, ValidatorFn,
  Validators
} from '@angular/forms';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE,} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import * as _moment from 'moment';
import {catchError, map} from 'rxjs/operators';

import {PurchaseRequestFormService} from './purchase-request-form-service';
import {LogoType, PRFormCustomDetails, RequestedFormat} from "./PRFormCustomDetails";
import {forkJoin} from "rxjs";

// tslint:disable-next-line:no-duplicate-imports
// import { default as _rollupMoment } from 'moment';
const moment = _moment;

export const YEAR_MODE_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export enum Labels {
  FORM_INACTIVE = "form_inactive",
  SUB_SUC = "subscription_success",
  DEF_FORM_SUBTITLE = "default_form_subtitle",
  EMAIL = "email",
  NAME = "name",
  SUB_FAIL = "subscription_fail",
  DEF_TITLE = "def_title",
  SUBMIT_REQUEST = "submit_request",
  REQUESTED_FORMAT = "requested_format",
  ELECTRONIC = "electronic",
  PHYSICAL = "physical",
  LOGO = "logo",
  TXT_IS_BLANK_ERROR = "txt_is_blank_error",
  FIELD_IS_MANDATORY_ERROR = "field_is_mandatory_error",
  INVALID_NAME_ERROR = "invalid_name_error",
  MISSING_NAME_ERROR = "missing_name_error",
  INVALID_EMAIL_ERROR = "invalid_email_error",
  MISSING_EMAIL_ERROR = "missing_email_error",
  INVALID_ISBN_ERROR = "invalid_isbn_error"
}

@Component({
  selector: 'purchase-request-form',
  templateUrl: './purchase-request-form.component.html',
  styleUrls: ['./purchase-request-form.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_MODE_FORMATS },
  ],
  encapsulation: ViewEncapsulation.None
})
export class PurchaseRequestFormComponent implements OnInit {


  fields;
  PRForm: FormGroup;
  prFormCustomDetails: PRFormCustomDetails;
  isElectronicChecked = true;
  isPrintChecked = false;
  format;
  isSubmitting = false;
openSubBanner: boolean = false;
isSucSubmit: boolean = false;
  subSucBoxInfo: string;
  emailRegex: RegExp;
  emailRegexFetched: boolean = false;
  //Labels to translate
  labelsToTranslate: Map<string, string>;
  private readonly REQ_TITLE_PLACEHOLDER = "{{titleName}}";


  @ViewChild('formDirective') private formDirective: NgForm;

  defTitleRialtoLabel: string = 'ng.rialto.pr_form_def_title';
  //translated labels
  formInactiveBoxInfo: string;
  defTitle: string;
  subSucBoxInfoTemplate: string;
  subFailBoxInfo: string;
  defSubtitle: string;
  emailLabel: string;
  nameLabel: string;
  submitRequest: string;
  requestedFormat: string;
  electronic: string;
  physical: string;
  logoLabel: string;
  txtIsBlankError: string;
  fieldIsMandatoryError: string;
  invalidNameError: string;
  missingNameError: string;
  invalidEmailError: string;
  missingEmailError: string;
  invalidIsbnError: string;
  blackOrWhiteText: string;

  @ViewChild(FormGroupDirective, { static: true }) formGroupDirective: FormGroupDirective;
  constructor(
    private purchaseRequestFormService: PurchaseRequestFormService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private titleService: Title,
    public sanitizer: DomSanitizer) {
          this.titleService.setTitle('Purchase Request');
    }

  ngOnInit() {
    const institutionCode = this.activatedRoute.snapshot.params.id;
    this.purchaseRequestFormService.institutionCode = institutionCode;
    this.purchaseRequestFormService.getEmailRegexCustomerParam().subscribe((data: string) => {
      data = data.replace(/\|.*$/, '');//we remove the | and everything after it to avoid match to empty string
      this.emailRegex = new RegExp(data);
      this.emailRegexFetched = true;
    });
    forkJoin([this.initCustomDetailsAndTranslations(),this.purchaseRequestFormService.getPurchaseRequestFormMappingTable()])
    .subscribe(( data:any) => {
            this.fields = data[1].filter(field => (field.enabled)).sort((a, b) => a.position - b.position);
      this.fields.map(field => this.setIsFieldMandatory(field));
      this.initForm();
    })
  }

  setIsFieldMandatory(field){
    if(field){
      field.isMandatory = (field.isMandatory == "true" || field.isMandatory == "True") ? "true": "false";
    }
  }

  private initCustomDetailsAndTranslations(){
    this.initLabelsToTranslate();
    return forkJoin(
      this.purchaseRequestFormService.getPRFormTranslations(this.labelsToTranslate), this.purchaseRequestFormService.getPRFormCustomDetails()
    ).pipe(map((res) => {
      this.initTranslatedLabels(res[0]);
      this.initFormCustomDetails(res[1]);
    }));
  }

  initLabelsToTranslate(){
    this.labelsToTranslate = new Map();
    this.labelsToTranslate.set(Labels.FORM_INACTIVE, 'purchase.request.form.labels.form_inactive');
    this.labelsToTranslate.set(Labels.SUB_SUC, 'purchase.request.form.labels.form_subscription_suc');
    this.labelsToTranslate.set(Labels.DEF_FORM_SUBTITLE, 'purchase.request.form.labels.form_sub_title');
    this.labelsToTranslate.set(Labels.NAME, 'purchase.request.form.labels.name');
    this.labelsToTranslate.set(Labels.EMAIL, 'purchase.request.form.labels.email');
    this.labelsToTranslate.set(Labels.SUB_FAIL, 'purchase.request.form.subscription_fail');
    this.labelsToTranslate.set(Labels.DEF_TITLE, 'purchase.request.form.title');
    this.labelsToTranslate.set(Labels.SUBMIT_REQUEST, 'purchase.request.form.submit_request');
    this.labelsToTranslate.set(Labels.REQUESTED_FORMAT, 'purchase.request.form.requested_format');
    this.labelsToTranslate.set(Labels.ELECTRONIC, 'purchase.request.form.format_electronic');
    this.labelsToTranslate.set(Labels.PHYSICAL, 'purchase.request.form.format_physical');
    this.labelsToTranslate.set(Labels.LOGO, 'purchase.request.form.inst_logo');
     this.labelsToTranslate.set(Labels.TXT_IS_BLANK_ERROR, 'purchase.request.form.labels.txt_is_blank_error');
    this.labelsToTranslate.set(Labels.FIELD_IS_MANDATORY_ERROR, 'purchase.request.form.labels.field_is_mandatory_error');
    this.labelsToTranslate.set(Labels.INVALID_NAME_ERROR, 'purchase.request.form.labels.invalid_name_error');
    this.labelsToTranslate.set(Labels.MISSING_NAME_ERROR, 'purchase.request.form.labels.missing_name_error');
    this.labelsToTranslate.set(Labels.INVALID_EMAIL_ERROR, 'purchase.request.form.labels.invalid_email_error');
    this.labelsToTranslate.set(Labels.MISSING_EMAIL_ERROR, 'purchase.request.form.labels.missing_email_error');
    this.labelsToTranslate.set(Labels.INVALID_ISBN_ERROR, 'purchase.request.form.labels.invalid_isbn_error');
  }

initTranslatedLabels(translatedLabels: object){
    this.formInactiveBoxInfo = translatedLabels[Labels.FORM_INACTIVE];
  this.subSucBoxInfoTemplate = translatedLabels[Labels.SUB_SUC];
  this.subFailBoxInfo = translatedLabels[Labels.SUB_FAIL];
  this.defSubtitle = translatedLabels[Labels.DEF_FORM_SUBTITLE];
  this.emailLabel = translatedLabels[Labels.EMAIL];
  this.nameLabel = translatedLabels[Labels.NAME];
  this.defTitle = translatedLabels[Labels.DEF_TITLE];
  this.submitRequest = translatedLabels[Labels.SUBMIT_REQUEST];
  this.requestedFormat = translatedLabels[Labels.REQUESTED_FORMAT];
  this.physical = translatedLabels[Labels.PHYSICAL];
  this.electronic = translatedLabels[Labels.ELECTRONIC];
  this.logoLabel = translatedLabels[Labels.LOGO];
  this.txtIsBlankError = translatedLabels[Labels.TXT_IS_BLANK_ERROR];
  this.fieldIsMandatoryError = translatedLabels[Labels.FIELD_IS_MANDATORY_ERROR];
  this.invalidNameError = translatedLabels[Labels.INVALID_NAME_ERROR];
  this.missingNameError = translatedLabels[Labels.MISSING_NAME_ERROR];
  this.invalidEmailError = translatedLabels[Labels.INVALID_EMAIL_ERROR];
  this.missingEmailError = translatedLabels[Labels.MISSING_EMAIL_ERROR];
  this.invalidIsbnError = translatedLabels[Labels.INVALID_ISBN_ERROR];
}

  initFormCustomDetails(customDetails: object){
      this.prFormCustomDetails = new PRFormCustomDetails((customDetails));
        this.prFormCustomDetails.formTitle = (!this.prFormCustomDetails.formTitle || this.prFormCustomDetails.formTitle === this.defTitleRialtoLabel)
                                             ? this.defTitle : this.prFormCustomDetails.formTitle;
      this.prFormCustomDetails.formSubtitle = (!this.prFormCustomDetails.formSubtitle || this.prFormCustomDetails.formSubtitle.length === 0)
                                              ? this.defSubtitle : this.prFormCustomDetails.formSubtitle;
      this.prFormCustomDetails.selectedLogoPath = (this.prFormCustomDetails.logoType === LogoType.NO_LOGO ||
                                             !this.prFormCustomDetails.selectedLogoPath) ? '' : this.prFormCustomDetails.selectedLogoPath + "?institutionCode=" + this.purchaseRequestFormService.institutionCode;
      this.blackOrWhiteText = this.getTextColor(this.prFormCustomDetails.formColor);
      document.documentElement.style.setProperty('--radio-button-theme-color',this.prFormCustomDetails.formColor);
      document.documentElement.style.setProperty('--textAccesibleColor', this.blackOrWhiteText);
  }

  initForm() {
    const form: any = {
       email: ['', [this.strictEmailValidator()]],
       name: '',
      'format.value': this.calcDefaultValueForRequestedFormat(),
    };
    this.fields?.forEach(field => {
      form[field.fieldName] = ['', this.getFieldValidators(field)];
      field.selLabel = field.label.split(' ').join('-').toLowerCase();
    });
    this.PRForm = this.formBuilder.group(form);
  }

  getFieldValidators(field):ValidatorFn[]{
    let validators = [];
    validators.push( Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/));//validate the fields don't contains only spaces

    if(field.fieldName === 'resource_metadata.isbn'){
      validators.push(this.isbnValidator());
    }
    return validators;
  }

  calcDefaultValueForRequestedFormat(){
    let defaultValue = this.prFormCustomDetails.defaultRequestedFormat;
    defaultValue = (defaultValue === RequestedFormat.E && !this.prFormCustomDetails.displayElectronic) ? RequestedFormat.P :
      (defaultValue === RequestedFormat.P && !this.prFormCustomDetails.displayPhysical) ? RequestedFormat.E : defaultValue;

    return defaultValue;
  }

  private strictEmailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if(!this.emailRegex || !control.value)
        return null;
      if(control.value.trim() === '')//We will leave the check 'is empty' to the 'required' validator
        return null;
      const valid = this.emailRegex.test(control.value);
      return valid ? null : { 'email': true };
    };
  }

  private isbnValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if(!control.value || control.value.trim() === '')//We will leave the check 'is empty' to the 'required' validator
        return null;
      const isbnRegex = /^\d+X?$/;
      const valid = isbnRegex.test(control.value);
      return valid ? null : { 'isbn': true };
    };
  }

  onSubmit(PR) {
    this.isSubmitting = true;
    this.purchaseRequestFormService.submitPurchaseRequestForm(PR).pipe(catchError((error) => {
      this.onSubmitFailed();
      this.isSubmitting = false;
      return error;
    })).subscribe((data: any[]) => {
      this.onSubmitSuccess(PR['resource_metadata.title']);
      this.isSubmitting = false;
      window.scrollTo(0, 0);
      this.formDirective.resetForm();//to fix the errors on the form after submit
      this.initForm();//in order to set the default format
    });
  }

  private onSubmitSuccess(requestedTitle: string){

      this.openSubBanner = true;
      this.isSucSubmit = true;
    this.subSucBoxInfo = this.subSucBoxInfoTemplate.replace(this.REQ_TITLE_PLACEHOLDER, requestedTitle);
  }

  private onSubmitFailed(){
    this.openSubBanner = true;
    this.isSucSubmit = false;
  }

  closeBanner(){
    this.openSubBanner = false;
  }
  yearSelectedHandler(chosenDate, datepicker: MatDatepicker<any>) {
    this.PRForm.controls['resource_metadata.publication_year'].setValue(chosenDate, { emitEvent: false });
    datepicker.close();
  }
  onDatePickerOpened(){
    // we use setTimeout to 'wait' for all of the new elements to be loaded to the DOM and only then ask for an element
    setTimeout(()=> {document.getElementsByClassName('mat-calendar-period-button')[0].setAttribute('tabindex', '-1'); // there is only one datepicker element opened at a given time so the array size is always <= 1
    }, 0);
  }

  getTextColor(hex){
    let rgb = this.hexToRgb(hex);
    if(rgb){
      if((rgb.r * 0.299) + (rgb.g * 0.587) + (rgb.b * 0.144) > 186){
        return '#000000';
      }
      else{
        return '#FFFFFF';
      }
    }
    else{
      return '#000000';
    }

  }

  private hexToRgb(hex: string): {r: number, g: number, b: number } {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }
}
